import { useLocation } from '@tanstack/react-router'
import { useEffect } from 'react'
import { pushDataLayerEvent } from './utils.js'

const PageView = () => {
  // Only the pathname: with TanStack most modals live in search params, so
  // reacting to the whole location would push duplicated page_view events for
  // the same path.
  const pathname = useLocation({ select: (location) => location.pathname })

  useEffect(() => {
    const pageTitle =
      pathname === '/'
        ? 'Home'
        : pathname
            .substring(1)
            .split('/')
            .map(
              (segment) => segment.charAt(0).toUpperCase() + segment.slice(1)
            )
            .join(' ')

    pushDataLayerEvent('page_view', 'navigation', pathname, pageTitle)
  }, [pathname])

  return null
}

export default PageView
